import dayjs from 'dayjs';
import { ProgramEnum } from '@model/enumerations/program-enum.model';
import { ProgramModality } from '@model/enumerations/program-modality.model';

export interface IProgramNews {
  id?: number;
  programEnum?: ProgramEnum;
  programModality?: ProgramModality;
  position?: number;
  titlePT?: string;
  titleEN?: string;
  descriptionPT?: any;
  descriptionEN?: any;
  active?: boolean;
  startDate?: dayjs.Dayjs;
  endDate?: dayjs.Dayjs;
  editedDate?: dayjs.Dayjs;
  imageContentType?: string;
  image?: any;
  imageSmallContentType?: string;
  imageSmall?: any;
  imagesId?: number;
}

// noinspection JSUnusedGlobalSymbols
export class ProgramNews implements IProgramNews {
  constructor(
    public id?: number,
    public programEnum?: ProgramEnum,
    public programModality?: ProgramModality,
    public position?: number,
    public titlePT?: string,
    public titleEN?: string,
    public descriptionPT?: any,
    public descriptionEN?: any,
    public active?: boolean,
    public startDate?: dayjs.Dayjs,
    public endDate?: dayjs.Dayjs,
    public editedDate?: dayjs.Dayjs,
    public imageContentType?: string,
    public image?: any,
    public imageSmallContentType?: string,
    public imageSmall?: any,
    public imagesId?: number
  ) {
    this.active = this.active || false;
  }
}
